import { Address, Person } from '@cdaas/api-clients/dist/asset-user-openapi';
import { ProductOrder } from '@cdaas/api-clients/dist/order-openapi';

import * as actionTypes from './actionTypes';
import { ShopActions } from '../../types/actiontypes/shopActions';
import { removeStorageItems, setStorageItems } from '../../utils';
import { DeliveryMethodOfOrder, LocalBundleEnvelopeWithChosenMainVariant, User } from '../../types';

export const shopRequestStart = (): ShopActions => ({
  type: actionTypes.SHOP_REQUEST_START,
});

export const shopSetProduct = (product: LocalBundleEnvelopeWithChosenMainVariant): ShopActions => {
  if (product) setStorageItems(['tItem'], [product], 'session');
  return {
    type: actionTypes.SHOP_SET_PRODUCT,
    product,
  };
};

export const shopSetDeliveryDetails = (
  address: Address,
  contact: Person,
  isHomeDelivery: boolean,
  locationReference: string | null = null,
  invoicingAccountNumber: string | null = null,
): ShopActions => ({
  type: actionTypes.SHOP_SET_DELIVERY_DETAILS,
  deliveryAddress: address,
  deliveryContact: contact,
  isHomeDelivery,
  locationReference,
  invoicingAccountNumber,
});

export const shopRequestFailed = (errorMessage: string): ShopActions => ({
  type: actionTypes.SHOP_REQUEST_FAILED,
  errorMessage,
});

export const shopPurchaseSuccess = (): ShopActions => ({
  type: actionTypes.SHOP_PURCHASE_SUCCESS,
});

export const shopResetShop = (): ShopActions => ({
  type: actionTypes.SHOP_RESET_SHOP,
});

export const shopSetOrderResp = (response: ProductOrder, deliveryMethod: DeliveryMethodOfOrder): ShopActions => ({
  type: actionTypes.SHOP_SET_ORDER_RESP,
  orderResponse: response,
  deliveryMethod,
});

export const shopResetOrderResponseAndDelivery = (): ShopActions => {
  return {
    type: actionTypes.SHOP_RESET_ORDER_AND_DELIVERY,
  };
};

export const shopResetProduct = (): ShopActions => {
  removeStorageItems(['tItem'], 'session');
  return {
    type: actionTypes.SHOP_RESET_PRODUCT,
  };
};

export const shopSetOrderForOrganization = (): ShopActions => {
  setStorageItems(['tOrderForOrganization'], [true], 'session');
  return {
    type: actionTypes.SHOP_SET_ORDER_FOR_ORGANIZATION,
  };
};

export const shopClearOrderForOrganization = (): ShopActions => {
  removeStorageItems(['tOrderForOrganization'], 'session');
  return {
    type: actionTypes.SHOP_CLEAR_ORDER_FOR_ORGANIZATION,
  };
};

export const shopSetOrderOnBehalfPendingUserSelection = (): ShopActions => {
  return {
    type: actionTypes.SHOP_SET_ORDER_ON_BEHALF_PENDING_USER_SELECTION,
  };
};

export const shopClearOrderOnBehalfPendingUserSelection = (): ShopActions => {
  return {
    type: actionTypes.SHOP_CLEAR_ORDER_ON_BEHALF_PENDING_USER_SELECTION,
  };
};

export const shopSetOrderOnBehalfUser = (user: User): ShopActions => {
  setStorageItems(['tOOB'], [{ userId: user.id, userGroupId: user.user_group?.id }], 'session');
  return {
    type: actionTypes.SHOP_SET_ORDER_ON_BEHALF_USER,
    user,
  };
};

export const shopClearOrderOnBehalfUser = (): ShopActions => {
  removeStorageItems(['tOOB'], 'session');
  return {
    type: actionTypes.SHOP_CLEAR_ORDER_ON_BEHALF_USER,
  };
};
